module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "border": "1"
    }
  }, [_c('tr', [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('div', {
    ref: "chart",
    staticStyle: {
      "height": "300px",
      "margin-top": "40px"
    },
    attrs: {
      "id": "bar_dv",
      "height": "400"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3ec1d12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/activity/EchartsTest.vue
// module id = 1096
// module chunks = 2